import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class PassesService {

  constructor(private http: HttpClient) { }

  getCompanyPasses() {
    const id_business = localStorage.getItem('id_business');
    const url = `${AppSettings.API_URI_V2}/companies/${id_business}/discounts`;
    return this.http.get<any>(url).pipe(
      map(res => {
        const list = res.discounts || res.data || res || [];
        return Array.isArray(list) ? list.filter((d: any) => d.rule_type === 'pass' && d.active) : [];
      })
    );
  }

  getPassDetail(id: number) {
    const url = `${AppSettings.API_URI_V2}/discounts/${id}`;
    return this.http.get<any>(url).pipe(
      map(res => res.discount || res.data || res)
    );
  }

  /**
   * Mapa de un abono de butaca única: misma forma que el mapa por sesión, con
   * la ocupación unida de todos sus eventos y, en `unavailable_seats`, las
   * butacas sin entrada general en alguno de ellos. Es el mismo endpoint que
   * usa la web: en estos abonos las bloqueadas tampoco se venden en taquilla.
   */
  getPassSeatMap(idDiscount: number) {
    return this.http.get<any>(`${AppSettings.API_URI_V2}/passes/${idDiscount}/seat-map`);
  }

  /**
   * Desglose por evento (entrada, precio y descuento) de las butacas elegidas.
   * Sirve también de consulta "¿están libres en todo el abono?": si alguna no
   * lo está, responde 409. `eventId` indica en el mapa de qué evento se han
   * elegido; sin él, son butacas del mapa del abono.
   */
  quotePassSeats(idDiscount: number, seatIds: number[], eventId: number | null = null) {
    return this.http.post<any>(`${AppSettings.API_URI_V2}/passes/${idDiscount}/seat-quote`, { seat_ids: seatIds, event_id: eventId }).pipe(
      map(res => res.data)
    );
  }

  /**
   * Abono en butaca única (obligatoria u ofrecida): solo se mandan el abono y
   * las butacas; la entrada de cada evento (siempre la general) y las líneas
   * las resuelve el back. `eventId` va cuando las butacas se eligieron en el
   * mapa de un evento y no en el del abono.
   */
  addSingleSeatPassToCart(idDiscount: number, seatIds: number[], eventId: number | null = null) {
    const payload = {
      id_discount: idDiscount,
      seat_ids: seatIds,
      event_id: eventId,
      work_time_cash_register_id: localStorage.getItem('id_work_time')
    };
    return this.http.post<any>(`${AppSettings.API_URI_V2}/cart/addSingleSeatPass`, payload).pipe(
      map(data => data)
    );
  }

  addPassToCart(idDiscount: number, cartLines: { id_event: number; id_session: number; id_ticket: number; quantity: number }[]) {
    const payload = {
      id_discount: idDiscount,
      cart_lines: cartLines,
      work_time_cash_register_id: localStorage.getItem('id_work_time')
    };
    return this.http.post<any>(`${AppSettings.API_URI_V2}/cart/addPass`, payload).pipe(
      map(data => data)
    );
  }
}
